import { type Priority } from './Priority'

export interface PlanOrganizationTask {
  id: number
  taskName: string
  status: PlanOrganizationTaskStatus
  organizationName: string
  organizationType: string
  planOrganizationId: number
  organizationId: number
  annualPlanId: number
  dueDate: Date
  activities: Priority[]
  itemsNeedingReviewCount: number
}

export enum PlanOrganizationTaskStatus {
  NotStarted = 'Not Started',
  InProgress = 'In Progress',
  Drafting = 'Drafting',
  ReadyToSubmit = 'Ready to Submit',
  Submitted = 'Submitted',
  NeedsRevision = 'Needs Revision',
  Accepted = 'Accepted',
  UpdatesReady = 'Updates Ready',
  UpdatesInProgress = 'Updates In Progress',
  UpdatesSubmitted = 'Updates Submitted',
  UpdatesNeedsRevision = 'Updates Needs Revision',
  TrackingInProgress = 'Tracking In Progress',
  TrackingCompleted = 'Tracking Completed'
}

export const PriorityStatuses: PlanOrganizationTaskStatus[] = [
  PlanOrganizationTaskStatus.NotStarted,
  PlanOrganizationTaskStatus.InProgress,
  PlanOrganizationTaskStatus.Submitted,
  PlanOrganizationTaskStatus.NeedsRevision,
  PlanOrganizationTaskStatus.Accepted
]

export const MeetingScheduleStatuses: PlanOrganizationTaskStatus[] = [
  PlanOrganizationTaskStatus.NotStarted,
  PlanOrganizationTaskStatus.InProgress,
  PlanOrganizationTaskStatus.Accepted
]

export const BudgetStatuses: PlanOrganizationTaskStatus[] = [
  PlanOrganizationTaskStatus.Drafting,
  PlanOrganizationTaskStatus.ReadyToSubmit,
  PlanOrganizationTaskStatus.Submitted,
  PlanOrganizationTaskStatus.NeedsRevision,
  PlanOrganizationTaskStatus.Accepted
]

export enum PlanOrganizationTaskName {
  PriorityOne = 'Priority One',
  PriorityTwo = 'Priority Two',
  PriorityThree = 'Priority Three',
  PriorityFour = 'Priority Four',
  RcnOperations = 'RCN Operations',
  MeetingSchedule = 'Meeting Schedule',
  BudgetOverview = 'Budget Overview',
  SignContract = 'Sign Contract',
  AllPriorities = 'All Priorities',
  SupportCost = 'Support Cost',
  EPLITrainerInitialReview = 'EPLI Trainer Initial Review',
  EPLITrainerFinalReview = 'EPLI Trainer Final Review',
  PeerToPeerDataCollectionSystem = 'Peer to Peer Data Collection System',
  CoachingCapacityTool = 'Coaching Capacity Tool',
  FocusStudentDataBOY = 'BOY Focus Student Data',
  FocusStudentDataEOY = 'EOY Focus Student Data',
  CetaBOY = 'BOY CETA',
  CetaEOY = 'EOY CETA',
  ProgressReportMY = 'Mid Year Progress Report',
  ProgressReportEOY = 'End of Year Progress Report'
}
